module.exports = __webpack_public_path__ + "img/i1.36f3ac05.jpeg";